import React from 'react'

export default function ContactUs() {
  return (
    <div className='page-content'>Contact-us page</div>
  )
}
